<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';
  import { differenceInDays, formatDistanceToNowStrict } from 'date-fns';

  import { ActivityUserAgents } from '@client/components/activity-user-agents';

  import { ReportsService } from '@client/services/reports';

  import { getFlag } from '@client/utils/flags';

  import { ACTIVITY_EVENTS } from '@client/enums';

  import { formatDate, getDateObject } from '@common/utils/dates';
  import { generateUUID } from '@common/utils/strings';

  export let row = {};

  const id = generateUUID();

  $: date = getDateObject(row.lastactivity.utcts);
  $: days = !isNaN(date) && differenceInDays(new Date(), date);
  $: verb = row?.lastactivity?.verb || row?.lastactivity?.objecttype || 'sent';
  $: lastActivity = row?.lastactivity;
  $: latestEvent = ACTIVITY_EVENTS[verb] || ACTIVITY_EVENTS[row?.lastactivity?.objecttype] || ACTIVITY_EVENTS.sent;
</script>

<div title={formatDate(date, 'M/d/yyyy @ h:mm:ss')}>
  {#if !isNaN(date)}
    {#if days < 30}
      {formatDistanceToNowStrict(date, { addSuffix: true })}
    {:else}
      {formatDate(date, 'M/d/yyyy')}
    {/if}
  {:else}
    -
  {/if}
</div>

{#if latestEvent}
  <div id="tooltip-{id}" class="badge" style="background-color: {latestEvent.color};">
    {$format(latestEvent.label)}
  </div>

  <Tooltip target="tooltip-{id}">
    {#if lastActivity}
      {#await ReportsService.getRecipientReport({ email: row.lastactivity.recipient })}
        <div class="tooltip-section">
          <b>{$format('label.RECIPIENT')}</b>
          <div>{lastActivity.recipient}</div>
        </div>
      {:then recipientData}
        <div class="tooltip-section">
          {#if recipientData?.person?.name}
            <div>
              {#if recipientData.person.name.fullName}
                <div><b>{recipientData.person.name.fullName}</b></div>
              {:else}
                <div class="break">{recipientData.email}</div>
              {/if}

              {#if recipientData.person.employment?.title}
                <div class="title">{recipientData.person.employment.title}</div>
              {/if}

              {#if recipientData.person.name?.fullName}
                <div class="email">{recipientData.email}</div>
              {/if}
            </div>
          {:else}
            <div class="tooltip-section">
              <b>{$format('label.RECIPIENT')}</b>
              <div>{lastActivity.recipient}</div>
            </div>
          {/if}
        </div>
      {/await}

      <div class="tooltip-section">
        <b>{$format('label.DEVICE')}</b>
        <div>
          <ActivityUserAgents ua={lastActivity.note.ua} let:metadata>
            {metadata.map((config) => config.label).join(', ')}
          </ActivityUserAgents>
        </div>
      </div>

      <div class="tooltip-section">
        <b>{$format('label.LOCATION')}</b>
        <div class="location">
          <div>
            <i class={getFlag(lastActivity.note.country || 'United States')} />
            <span>{lastActivity.note.location || 'United States'}</span>
          </div>
          {#if lastActivity.note.isp}
            <div>
              {#if lastActivity.note.isp}
                {lastActivity.note.isp}
              {/if}
              {#if lastActivity.ip}
                - {lastActivity.ip}
              {/if}
            </div>
          {/if}
        </div>
      </div>

      <div class="tooltip-section">
        <div><b>{$format('label.TIMESTAMP')}</b></div>
        {formatDate(date, 'M/d/yyyy @ h:mm:ss a')}
      </div>
    {/if}
  </Tooltip>
{/if}

<style lang="scss">
  .badge {
    font-size: var(--font-size-small);
    margin-top: var(--margin-base);
  }

  .tooltip-section {
    + .tooltip-section {
      margin-top: var(--margin-base);
    }
  }
</style>
